module.exports = __webpack_public_path__ + "media/map/NJ_Icon-e8ca5df1.png";